import { GzWidgetHeaderItemWebComponent } from './component/GzWidgetHeaderItemWebComponent';

export { GzWidgetHeaderItemWebComponent };
